package com.merkost.handpass.api.enums

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class Condition(val value: String) {
    @SerialName("new") NEW("new"),
    @SerialName("like_new") LIKE_NEW("like_new"),
    @SerialName("used") USED("used");

    companion object {
        fun fromString(value: String): Condition =
            entries.find { it.value == value.lowercase() } ?: USED

        fun fromDbValue(value: String): Condition =
            entries.find { it.value == value.lowercase() } ?: LIKE_NEW
    }
}
